// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b0889ef2","952":"b4ee940d"}[chunkId] + ".chunk.js";
};